<template>
  <div class="message-component">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 back-row">
          <button class="btn btn-primary" v-on:click="back()">
            <i class="fa fa-backward" aria-hidden="true"></i> Voltar
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 title-col">
          <h5>{{formType == 'create' ? 'Nova Mensagem' : 'Editar Mensagem'}}</h5>
        </div>
        <div class="col-lg-12 col-12">
          <div class="form-group">
            <label for>
              Mensagem
              <span class="required-field">*</span>
            </label>
            <textarea type="text" v-model="message.message" class="form-control" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <button class="btn btn-primary float-right" v-on:click="save()">Salvar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import validator from "@/imports/validator/validate";
import message_validate from "@/imports/validator/models/message";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "message-component",
  props: {
    reported_error_id: Number,
  },
  data() {
    return {
      message: {},
      userLogged:0,
      formType: "create"
    };
  },
  mounted(){
      this.getUserLogged();
  },
  methods: {
    editMessage: function(item){
      this.formType = "edit";
      this.message = item;
    },
    back: function() {
      this.subindex = {};
      this.formType = "create";
      this.$emit("back");
    },
    getUserLogged: function(){
      let promise = axios.get(`${process.env.VUE_APP_API_HOST}/api/user_logged`)

      promise
          .then(response => {
            
            this.userLogged = response.data.id;
           
          })
          .catch(error => {
            bus.$emit('changeLoading', false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error"
            });
          });
    },
    save: function() {
      //validar
      let errors = validator.validate(this.message, message_validate.model);
      if (errors.length == 0) {
        bus.$emit('changeLoading', true);
        this.message.user_id = this.userLogged;
        this.message.reported_error_id = this.reported_error_id;
        let promise =
          this.formType == "create"
            ? axios.post(
                `${process.env.VUE_APP_API_HOST}/api/reported_error_message`,
                this.message
              )
            : axios.put(
                `${process.env.VUE_APP_API_HOST}/api/reported_error_message/${this.message.id}`,
                this.message
              );

        promise
          .then(response => {
            bus.$emit('changeLoading', false);
            if (response.data.id) {
              Swal.fire({
                title:
                  this.formType == "create"
                    ? "Nova Mensagem cadastrada"
                    : "Mensagem alterada com sucessa",
                icon: "success",
                onClose: () => {
                  this.back();
                }
              });
            }
          })
          .catch(error => {
            bus.$emit('changeLoading', false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error"
            });
          });
      } else {
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach(el => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning"
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.message-component {
  .back-row {
    margin-bottom: 15px;
  }
  .title-col {
    padding-top: 8px;
    padding-bottom: 12px;
  }
}
</style>
